const groupingsColumns = {
  groupingId: {
    key: 'id',
    label: 'grouping',
    type: 'function',
    sortable: false,
    get: (value, row) => (row.children ? value : row.code),
  },
  analysisDescription: {
    key: 'description',
    label: 'analysisDescription',
    type: 'function',
    sortable: false,
    get: (value, row) => (row.children ? '' : value),
  },
  createdAt: {
    key: 'createdAt',
    label: 'createdAt',
    type: 'date',
    sortable: false,
  },
  updatedAt: {
    key: 'updatedAt',
    label: 'updatedAt',
    type: 'date',
    sortable: false,
  },
  labSampleCode: {
    key: 'samples',
    label: 'samplesCount',
    type: 'text',
    sortable: false,
    minWidth: 150,
  },
};

export default groupingsColumns;
